var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59486 12.0417C2.89574 3.21944 9.14536 0.716894 14.1469 1.57539C14.3495 4.49939 12.9187 5.59377 10.1944 6.09952C10.72 6.64919 11.65 7.34123 11.5494 8.2061C11.4786 8.82094 11.0607 9.12339 10.2249 9.72689C8.39311 11.0501 6.27095 11.8859 3.59486 12.0417Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83301 15.5834C2.83301 10.9792 5.55867 8.62896 7.43717 7.08337",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewrite);
export default __webpack_public_path__ + "static/media/rewrite.04069eb108a24cc28471efbbefffdeba.svg";
export { ForwardRef as ReactComponent };